export enum TripType {
    OneWay = 'ONE WAY',
    Return = 'RETURN',
    MultiLeg = 'MULTI-LEG'
}
